/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Box, Loader, Text } from "@nordcloud/gnui";
import { ServiceAndGroupAssign } from "~/components/Services/ServiceAndGroupAssign/ServiceAndGroupAssign";
import FlexContainer from "~/components/Styled/FlexContainer";
import { ServiceItem } from "./ServiceItem";
import { ServiceAttachment } from "./types";

type ServiceEnvironmentProps = {
  isLoading: boolean;
  serviceAttachments: ServiceAttachment[];
  fetchServicesAttachments: () => Promise<void>;
  refetch: () => void;
  envName: string;
  envId: string;
  canEdit?: boolean;
};

function ServiceEnvironment({
  isLoading,
  serviceAttachments,
  refetch,
  envName,
  fetchServicesAttachments,
  envId,
  canEdit,
}: ServiceEnvironmentProps) {
  return (
    <Box spacing="spacing04">
      <FlexContainer>
        <Text weight="medium">Services</Text>
        <ServiceAndGroupAssign
          serviceAttachments={serviceAttachments}
          refetch={fetchServicesAttachments}
          envId={envId}
        />
      </FlexContainer>
      {isLoading ? (
        <Loader inContent />
      ) : (
        serviceAttachments?.map((serviceAttachment: ServiceAttachment) => {
          return (
            <ServiceItem
              key={serviceAttachment.service.id}
              envName={envName}
              refetch={refetch}
              serviceAttachment={serviceAttachment as ServiceAttachment}
              canEdit={canEdit}
            />
          );
        })
      )}
      {!isLoading && serviceAttachments.length === 0 && (
        <Text tag="span">No data.</Text>
      )}
    </Box>
  );
}

export { ServiceEnvironment };
